function directive($location, $window, fetchStream, generateId, usSpinnerService) {
    return {
        link: function ($scope, element, attrs) {
            $scope.page.w = angular.element($window);
            let group, searchCategories, uid, key;
            let width = element[0].clientWidth-20
            let height = $scope.page.w[0].innerHeight+50
            $scope.$on('init', function (event, chart) {
                if (chart.id !== attrs.uid) { return }
                if (typeof $scope.main.dataObjects[chart.key] === 'undefined') { return } // if its not in our dc object, ignore
                $scope.main.dataObjects[chart.key].launched = true;
                uid = chart.id;
                key = chart.key;

                group = $scope.main.dataObjects[key].group;
                searchCategories = $scope.main.dataObjects[key].settings.searchCategories;
                let socket = $scope.main.dataObjects[key].settings.get.socket;
                let tableCalls = $scope.main.dataObjects[key].settings.get.call;
                let selectedModifiers = document.getElementById("selectedModifiers");

                let outterDiv =  d3.select(element[0]).append("div").attr("id","services")
                let svg = outterDiv.append("svg");
                svg.attr("width",width).attr("height",height);
                svg.on('dblclick', function () {
                    $scope.$apply(function () {
                        clearFilters("all")
                    })
                })
                let linksSVG = svg.append("g").attr("class", "links")
                let serviceSVG = svg.append("g").attr("class", "services")
                let serverSVG = svg.append("g").attr("class", "servers")
                let clientSVG = svg.append("g").attr("class", "clients")

                let services = {},
                    servers = {},
                    clients = {},
                    apps = {},
                    selectedMap = {},
                    allMap = {};
                let filtersObj = {
                    server: {},
                    service: {}
                };

                let boxWidth = 200,
                    boxHeight = 20,
                    boxSpace = 1.5,
                    padding_bottom = 45,
                    circleRadius = 6,
                    circleStroke = 2,
                    bounceTime = 1000,
                    oldY = 0;

                let transitionEffect = "elastic", highlightColor = "#0da4d3", iocColor = "#D60A04", highlightIOCColor = "#410069", servicesColor = "#000", appsColor = "#2E7A1C", linechartKey = "", linechartID = "";
                let filter_vector = "";
                let toggleFlag = true, lineChartReq = false;
                let filtersOn = {}, points = [];

                let hideLineChart = d3.select('#hideLineChart');

                let buttonContainer = document.getElementById("buttonContainer")
                let allButton = document.createElement("div");
                allButton.className = "vectors current";
                allButton.innerHTML = "All";

                let inButton = document.createElement("div");
                inButton.className = "vectors";
                inButton.innerHTML = "Inbound";

                let latButton = document.createElement("div");
                latButton.className = "vectors";
                latButton.innerHTML = "Lateral";

                let outButton = document.createElement("div");
                outButton.className = "vectors";
                outButton.innerHTML = "Outbound";

                let vectors = document.getElementsByClassName("vectors")
                allButton.onclick = function () {
                    handleVectors("vector","all");
                };
                inButton.onclick = function () {
                    handleVectors("all","inbound");
                };
                latButton.onclick = function () {
                    handleVectors("all","lateral");
                };
                outButton.onclick = function () {
                    handleVectors("all","outbound");
                };

                function handleVectors (clear, value) {
                    clearFilters(clear);
                    if (value !== "all") {
                        $scope.$apply(function () {
                            $scope.main.filterItem("vector", value, "include", "Vector", false);
                        })
                    }
                    for (let i = 0; i < vectors.length; i++) {
                        vectors[i].className = "vectors";
                    }
                    if (value === "inbound") {
                        inButton.className = "vectors current";
                    } else if (value === "lateral") {
                        latButton.className = "vectors current";
                    } else if (value === "outbound") {
                        outButton.className = "vectors current";
                    } else {
                        allButton.className = "vectors current";
                    }
                }
                buttonContainer.appendChild(allButton)
                buttonContainer.appendChild(inButton)
                buttonContainer.appendChild(latButton)
                buttonContainer.appendChild(outButton)

                let servicesLineChart = d3.select('.servicesLineChart');
                let lineChartHeight
                if (servicesLineChart[0][0]) {
                    lineChartHeight = servicesLineChart[0][0].clientHeight;
                    if ($scope.page.settings.get("hideLineChart")) {
                        servicesLineChart.classed("hlcHide", true);
                        hideLineChart[0][0].innerHTML = "+";
                    } else {
                        hideLineChart[0][0].innerHTML = "-";
                    }
                    hideLineChart.on('click', function () {
                        if (this.innerHTML === "-") {
                            this.innerHTML = "+";
                            servicesLineChart.classed("hlcHide", true);
                            $scope.page.settings.set('hideLineChart', true);
                        } else if (this.innerHTML === "+") {
                            this.innerHTML = "-";
                            servicesLineChart.classed("hlcHide", false);
                            $scope.page.settings.set('hideLineChart', false);
                        }
                    });
                }

                let diagonal = d3.svg.diagonal()
                    .source(function (d) {
                        if (d.type === "server") {
                            return {
                                "x": (d.source.y+(boxHeight/2)),
                                "y": (d.source.xr)
                            };
                        }
                        return {
                            "x": (d.source.y+(boxHeight/2)),
                            "y": (d.source.x+(boxHeight/2))
                        };
                    })
                    .target(function (d) {
                        if (d.type === "server") {
                            return {
                                "x": (d.target.y+(circleRadius+circleStroke)),
                                "y": (d.target.xr+(circleRadius+circleStroke))
                            };
                        }
                        return {
                            "x": (d.target.y+(circleRadius+circleStroke)),
                            "y": (d.target.x+(circleRadius+circleStroke))
                        };
                    })
                    .projection(function (d) {
                        return [d.y, d.x];
                    });

                // ---------- Small General Functions ----------
                function setHeight() {
                    svg.attr("height",height+30);
                }
                var sort_by = function (field, reverse, primer) {
                    var key = primer ? function (x) { return primer(x[field])} : function (x) { return x[field] };
                    reverse = !reverse ? 1 : -1;
                    return function (a, b) {
                       return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
                    }
                }
                function getName(X) {
                    return X.name
                }
                function serverContains(arr, val) {
                    for (let a in arr) {
                        if (arr[a].name === val.name) {
                            return true;
                        }
                    }
                    return false;
                }
                function checkSelect(X, item, Z) {
                    return selectedMap[X.name] ? Z : item
                }

                // ---------- Functions to populate chart ----------
                function setServices() {
                    let servGroup = $scope.main.dataObjects[key].group.all();
                    for (let g in servGroup) {
                        if (servGroup[g].key === servGroup[g].value.name) {
                            if (!services[servGroup[g].value.name]) {
                                services[servGroup[g].value.name] = servGroup[g].value
                            }
                            services[servGroup[g].value.name].visible = true;
                        } else {
                            delete services[servGroup[g].key]
                        }
                    }
                }
                function makeServicesArray() {
                    let servArray = [];
                    for (let s in services) {
                        if ((services[s].tot_count > 0) || (services[s].tot_total_bytes > 0)) {
                            servArray.push(services[s])
                        }
                    }
                    servArray.sort(sort_by("service", false, String))
                    return servArray;
                }
                function servicesLength() {
                    let count = 0;
                    for (let s in services) {
                        if ((services[s].visible) && ((services[s].tot_count > 0) || (services[s].tot_total_bytes > 0))) {
                            count++;
                        }
                    }
                    return count;
                }
                function setServers() {
                    servers = {};
                    for (let s in services) {
                        for (let e in services[s].servers) {
                            if (!servers[services[s].servers[e].name]) {
                                servers[services[s].servers[e].name] = services[s].servers[e]
                            }
                        }
                    }
                }
                function makeServersArray() {
                    let serverArray = [];
                    for (let e in servers) {
                        serverArray.push(servers[e])
                    }
                    serverArray.sort(sort_by("name", true, String))
                    return serverArray;
                }
                function getClients() {
                    let alreadyFiltered = $scope.main.dataObjects[key].filters.include;
                    let proto = false, service = false, server = false;
                    for (let af in alreadyFiltered) {
                        if ((alreadyFiltered[af].resp_ip) || (alreadyFiltered[af].resp_country)) {
                            server = true;
                        } else if (alreadyFiltered[af].proto) {
                            proto = true;
                        } else if (alreadyFiltered[af].service) {
                            service = true;
                        }
                    }
                    if ((!proto) || (!service) || (!server)) {
                        return;
                    }
                    let table = [];
                    filtersObj = {}

                    let serversArr = makeServersArray();

                    if (serversArr[0].type === "internal") {
                        table.push("orig_int_int");
                        table.push("orig_int_ext");
                        filtersObj.resp_ip = serversArr[0].ip;
                        filtersObj.resp_hostname = serversArr[0].hostname;
                        $scope.main.dataObjects[key].settings.complete = $scope.main.dataObjects[key].settings.complete - 2;
                    } else if (serversArr[0].type === "external") {
                        table.push("orig_ext_int");
                        filtersObj.resp_country = serversArr[0].name_toggle;
                        $scope.main.dataObjects[key].settings.complete--;
                    }

                    let servicesArr = makeServicesArray();
                    filtersObj.service = servicesArr[0].service;
                    filtersObj.proto = servicesArr[0].proto;

                    $scope.page.complete = false;
                    usSpinnerService.spin("spinner-"+uid)
                    for (let t in table) {
                        new fetchStream(table[t], socket, filtersObj).then(function (result) {
                            $scope.main.dataObjects[key].settings.complete++;
                            if ($scope.main.dataObjects[key].settings.complete >= tableCalls.length) {
                                $scope.page.complete = true;
                                usSpinnerService.stop("spinner-"+uid)
                            }
                        }, function (err) {
                        }, function (result) {
                            $scope.main.dataObjects[key].cf.add(result.rows);
                            setClients();
                            drawClients();
                            setApplications();
                            drawApplications();
                            setHeight();
                            setLinks();
                            drawLinks();
                        })
                    }
                    if (!lineChartReq) {
                        requeryLineChart(filtersObj);
                    }
                }
                function setClients() {
                    clients = {};
                    for (let s in services) {
                        for (let c in services[s].clients) {
                            if (!clients[services[s].clients[c].name]) {
                                clients[services[s].clients[c].name] = services[s].clients[c]
                            }
                        }
                    }
                }
                function makeClientsArray() {
                    let clientArray = [];
                    for (let c in clients) {
                        clientArray.push(clients[c])
                    }
                    clientArray.sort(sort_by("name", true, String))
                    return clientArray;
                }
                function setApplications() {
                    apps = {};
                    for (let s in services) {
                        for (let e in services[s].l7_apps) {
                            if (!apps[services[s].l7_apps[e].name]) {
                                apps[services[s].l7_apps[e].name] = services[s].l7_apps[e]
                            }
                        }
                    }
                }
                function makeApplicationArray() {
                    let appArray = [];
                    for (let a in apps) {
                        appArray.push(apps[a])
                    }
                    appArray.sort(sort_by("name", false, String))
                    return appArray;
                }
                function setLinks() {
                    points = [];
                    let val = false;
                    if (Object.keys(apps).length > 0) {
                        for (let a in apps) {
                            if (allMap[apps[a].name+"application"]) {
                                for (let i in apps[a].servers) {
                                    if (allMap[apps[a].servers[i].name+"server"]) {
                                        val = false;
                                        if ((apps[a].servers[i].ioc_count > 0) && (apps[a].ioc_count > 0)) {
                                            val = true;
                                        }
                                        points.push({
                                            name: apps[a].name+"-to-"+apps[a].servers[i].name,
                                            type: "server",
                                            source: allMap[apps[a].name+"application"],
                                            target: allMap[apps[a].servers[i].name+"server"],
                                            ioc: val,
                                        })
                                    }
                                }
                                for (let c in apps[a].clients) {
                                    if (allMap[apps[a].clients[c].name+"client"]) {
                                        val = false;
                                        if ((apps[a].clients[c].ioc_count > 0) && (apps[a].ioc_count > 0)) {
                                            val = true;
                                        }
                                        points.push({
                                            name: apps[a].clients[c].name+"-to-"+apps[a].name,
                                            type: "client",
                                            source: allMap[apps[a].name+"application"],
                                            target: allMap[apps[a].clients[c].name+"client"],
                                            ioc: val,
                                        })
                                    }
                                }
                            }
                        }
                    } else {
                        for (let s in services) {
                            if (allMap[services[s].name+"service"]) {
                                for (let i in services[s].servers) {
                                    if (allMap[services[s].servers[i].name+"server"]) {
                                        val = false;
                                        if ((services[s].servers[i].ioc_count > 0) && (services[s].ioc_count > 0)) {
                                            val = true;
                                        }
                                        points.push({
                                            name: services[s].name+"-to-"+services[s].servers[i].name,
                                            type: "server",
                                            source: allMap[services[s].name+"service"],
                                            target: allMap[services[s].servers[i].name+"server"],
                                            ioc: val,
                                        })
                                    }
                                }
                                for (let c in services[s].clients) {
                                    if (allMap[services[s].clients[c].name+"client"]) {
                                        val = false;
                                        if ((services[s].clients[c].ioc_count > 0) && (services[s].ioc_count > 0)) {
                                            val = true;
                                        }
                                        points.push({
                                            name: services[s].clients[c].name+"-to-"+services[s].name,
                                            type: "client",
                                            source: allMap[services[s].name+"service"],
                                            target: allMap[services[s].clients[c].name+"client"],
                                            ioc: val,
                                        })
                                    }
                                }
                            }
                        }
                    }
                }

                // ---------- Utility Functions ----------
                function clearClients() {
                    $scope.main.dataObjects[key].searchDimension.filterAll();
                    $scope.main.dataObjects[key].searchDimension.filter(function (d) {
                        return (
                            (d.resp_ip && d.orig_ip) ||
                            (d.resp_country && d.orig_ip) ||
                            (d.resp_ip && d.orig_country)
                        )
                    });
                    $scope.main.dataObjects[key].cf.remove();
                    $scope.main.dataObjects[key].searchDimension.filterAll();
                    $scope.main.runFilters();
                    clients = {};
                }
                function clearApps() {
                    apps = {};
                }
                function addToFilterList(action, value, column, columnTitle) {
                    // clear the pInput
                    $scope.$apply(function () {
                        $scope.main.addFilter(column, value, action, true, columnTitle);
                    })
                }
                function clickEvent(node,index) {
                    if ($scope.page.complete) {
                        let title = [], filter = [], value = [], id = [];
                        let alreadyFiltered = $scope.main.dataObjects[key].filters.include;
                        let matching = alreadyFiltered.filter(function (f) { return (f.orig_ip || f.orig_country) })
                        if (matching.length > 0) {
                            for (let m in matching) {
                                if (matching[m].orig_ip) {
                                    $scope.main.removeFilter("orig_ip", matching[m].orig_ip, "include", true, searchCategories.orig_ip+': ');
                                } else {
                                    $scope.main.removeFilter("orig_country", matching[m].orig_country, "include", true, searchCategories.orig_country+': ');
                                }
                            }
                        }
                        if (node.type.indexOf("orig") !== -1) {
                            let childNode = false;
                            switch (node.type) {
                                case "orig_internal":
                                    // id.push(generateId())
                                    title.push(searchCategories.orig_ip+': ');
                                    value.push(node.ip);
                                    filter.push("orig_ip");
                                    break;
                                case "orig_external":
                                    // id.push(generateId())
                                    title.push(searchCategories.orig_country+': ');
                                    value.push(node.name_toggle);
                                    filter.push("orig_country");
                                    break;
                            }
                            for (let f in filter) {
                                addToFilterList("include", value[f], filter[f], title[f])
                            }
                        } else {
                            let proto = false, service = false;
                            switch (node.type) {
                                case "internal":
                                    clearClients();
                                    title.push(searchCategories.resp_ip);
                                    value.push(node.ip);
                                    filter.push("resp_ip");
                                    break;
                                case "external":
                                    clearClients();
                                    title.push(searchCategories.resp_country);
                                    value.push(node.name_toggle);
                                    filter.push("resp_country");
                                    break;
                                case "application":
                                    title.push(searchCategories.l7_app);
                                    value.push(node.name);
                                    filter.push("l7_app");
                                    break;
                                default:
                                    clearClients();
                                    for (let af in alreadyFiltered) {
                                        if (alreadyFiltered[af].proto) {
                                            proto = true;
                                        } else if (alreadyFiltered[af].service) {
                                            service = true;
                                        }
                                    }
                                    if ((proto) && (!service)) {
                                        title.push(searchCategories.service);
                                        value.push(node.service);
                                        filter.push("service");
                                        node.show_applications = true;
                                    } else if ((!proto) && (service)) {
                                        title.push(searchCategories.proto);
                                        value.push(node.proto);
                                        filter.push("proto");
                                        node.show_applications = true;
                                    } else {
                                        if (node.show_applications) {
                                            node.show_applications = false;
                                        } else {
                                            node.show_applications = true;
                                        }
                                        title.push(searchCategories.service);
                                        value.push(node.service);
                                        filter.push("service");
                                        title.push(searchCategories.proto);
                                        value.push(node.proto);
                                        filter.push("proto");
                                    }
                                    if (filtersOn.l7_app) {
                                        clearFilters("l7_app", filtersOn);
                                    }
                                    break;
                            }
                            for (let v in value) {
                                if (filtersOn[filter[v]]) {
                                    if (filtersOn[filter[v]] === value[v]) {
                                        delete filtersOn[filter[v]];
                                    } else {
                                        filtersOn[filter[v]] = value[v]
                                    }
                                } else {
                                    filtersOn[filter[v]] = value[v]
                                }
                            }

                            if (alreadyFiltered.length > 0) {
                                for (let f in filter) {
                                    for (let af in alreadyFiltered) {
                                        if (alreadyFiltered[af][filter[f]]) {
                                            if (alreadyFiltered[af][filter[f]] !== value[f].toLowerCase()) {
                                                $scope.$apply(function () {
                                                    $scope.main.filterItem(filter[f], alreadyFiltered[af][filter[f]], "include", title[f]);
                                                })
                                            }
                                        }
                                    }
                                }
                            }
                            for (let f in filter) {
                                $scope.$apply(function () {
                                    $scope.main.filterItem(filter[f], value[f], "include", title[f], false);

                                })
                            }
                            if ((filtersOn.resp_ip || filtersOn.resp_country) && (filtersOn.service && filtersOn.proto) && (makeClientsArray().length === 0)) {
                                getClients();
                            }
                        }
                    }
                }
                function clearFilters(filter, values) {
                    let alreadyFiltered = $scope.main.dataObjects[key].filters.include;
                    let clearOn = [];
                    if (filter === "all") {
                        clearClients();
                        // for (let sm in selectedModifiers.childNodes) {
                        //     if (!isNaN(Number(sm))) {
                        //         if ((selectedModifiers.childNodes[sm].getAttribute('modifierselect') === "orig_ip") || (selectedModifiers.childNodes[sm].getAttribute('modifierselect') === "orig_country")) {
                        //             window.searchItemCloseClick(selectedModifiers.childNodes[sm].getAttribute('id'))
                        //             break;
                        //         }
                        //     }
                        // }
                        for (let a in alreadyFiltered) {
                            for (let f in alreadyFiltered[a]) {
                                clearOn.push({value:alreadyFiltered[a][f],filter:f,title:searchCategories[f]})
                                delete filtersOn[f];
                            }
                        }
                        for (let c in clearOn) {
                            $scope.main.filterItem(clearOn[c].filter, clearOn[c].value, "include", clearOn[c].title);
                        }
                    } else {
                        for (let a in alreadyFiltered) {
                            if (alreadyFiltered[a][filter]) {
                                $scope.main.filterItem(filter, alreadyFiltered[a][filter], "include", searchCategories[filter]);
                                delete filtersOn[filter];
                                break;
                            }
                        }
                    }
                }
                function insertModifier(title, filter, value, id, action, complete, searchState) {
                    if (typeof complete === 'undefined') { complete = false }
                    if (!searchState) { searchState = "false"}
                    let display = document.createElement("div");
                        display.className = 'searchSelected';
                        display.setAttribute('id', id);
                        display.setAttribute('action', action);
                        display.setAttribute('modifierselect', filter);
                        display.setAttribute('searchState', searchState);
                        display.setAttribute('value', value);
                        display.innerHTML = "<i onclick='searchItemCloseClick(\""+id+"\")' class='fa fa-times closeSearchObj'></i> "+title+value;
                        selectedModifiers.appendChild(display);
                }
                function selectHighlights(cur) {
                    selectedMap = {}
                    points.forEach(function (Y) {
                        if ((Y.source.name === cur.name) || (Y.target.name === cur.name)) {
                            if (typeof selectedMap[Y.name] === "undefined") {
                                selectedMap[Y.name] = true;
                            }
                            if (typeof selectedMap[Y.source.name] === "undefined") {
                                selectedMap[Y.source.name] = true;
                            }
                            if (typeof selectedMap[Y.target.name] === "undefined") {
                                selectedMap[Y.target.name] = true;
                            }
                        }
                    })
                    highlight();
                }
                function highlight() {
                    serviceSVG.selectAll("rect").attr("fill", function (X) {
                        if (X.type === "application") {
                            return checkSelect(X, appsColor, highlightColor)
                        }
                        return checkSelect(X, servicesColor, highlightColor)
                    });

                    serverSVG.selectAll("circle").attr("fill", function (X) {
                        return checkSelect(X, "#fff", highlightColor)
                    }).selectAll("text").attr("fill", function (X) {
                        return checkSelect(X, "#000", highlightColor)
                    });

                    clientSVG.selectAll("circle").attr("fill", function (X) {
                        return checkSelect(X, "#fff", highlightColor)
                    }).selectAll("text").attr("fill", function (X) {
                        return checkSelect(X, "#000", highlightColor)
                    });

                    linksSVG.selectAll("path").attr("stroke", function (X) {
                        if (X.ioc) {
                            return checkSelect(X, iocColor, highlightIOCColor)
                        }
                        return checkSelect(X, "#aaa", highlightColor)
                    }).attr("stroke-width", function (X) {
                        return checkSelect(X, "1.5px", "2.5px")
                    }).attr("opacity", function (X) {
                        return checkSelect(X, 0.4, 0.75)
                    });
                }
                function doHover(elm, data) {
                    let e = d3.select(elm);
                    e.attr("fill", "#049CCC")
                    data.hover = true;
                }
                function requeryLineChart(filtersObj) {
                    if ((linechartKey === "") || (linechartID === "")) {
                        linechartKey = $scope.page.lineChartIdentifiers.key;
                        linechartID = $scope.page.lineChartIdentifiers.id;
                    }
                    let crossLineChart = {};
                    if (filtersObj.resp_country) {
                        crossLineChart.resp_country = filtersObj.resp_country;
                        crossLineChart.proto = filtersObj.proto;
                        crossLineChart.service = filtersObj.service;
                        lineChartReq = true;
                    } else if ((filtersObj.resp_hostname) && (filtersObj.resp_ip)) {
                        crossLineChart.resp_hostname = filtersObj.resp_hostname;
                        crossLineChart.resp_ip = filtersObj.resp_ip;
                        crossLineChart.proto = filtersObj.proto;
                        crossLineChart.service = filtersObj.service;
                        lineChartReq = true;
                    } else {
                        lineChartReq = false;
                    }
                    $scope.page.complete = false;

                    $scope.main.dataObjects[linechartKey].searchDimension.filterAll(); // clear the search dimension
                    $scope.main.dataObjects[linechartKey].searchDimension.filter(function (d, i) { return true; }); // refilter down to what needs to be removed
                    $scope.main.dataObjects[linechartKey].cf.remove(); // delete the data that has been filtered
                    $scope.main.dataObjects[linechartKey].searchDimension.filterAll(); // clear the filter again


                    usSpinnerService.spin("spinner-"+linechartID)
                    $scope.page.complete = false;
                    new fetchStream("linechart", socket, crossLineChart).then(function (result) {
                        $scope.page.complete = true;
                        usSpinnerService.stop("spinner-"+linechartID)
                    }, function (err) {
                    }, function (result) {
                        $scope.main.dataObjects[linechartKey].cf.add(result.rows);
                        $scope.$broadcast('updatedData',linechartID, true)
                    })
                }
                function checkFilter(node) {
                    return node.visible
                }

                // ---------- Drawing Functions ----------
                function drawServices() {
                    let services = makeServicesArray();
                    oldY = 0;
                    serviceSVG.selectAll('.service').remove();
                    let servi = serviceSVG.selectAll(".service").data(services.filter(function (d) {  return checkFilter(d); }))
                    let serviceRect = servi.enter().append("g").attr("class", function (d) { return "service service-"+d.name;})
                    serviceRect.each(function (d, i) {
                        let elm = d3.select(this);
                        oldY = 0;
                        if (d.y) {
                            oldY = d.y
                        }
                        d.x = ((width/2)-(boxWidth/2));
                        d.xr = ((width/2)+(boxWidth/2));
                        d.y = (boxHeight)*i;
                        // if (d.type === "application") {
                        //     allMap[d.name+"application"] = d;
                        // } else if (d.type === "alphabet") {
                        //     allMap[d.name+"alphabet"] = d;
                        // } else {
                            allMap[d.name+"service"] = d;
                        // }
                        if (height < (d.y+padding_bottom)) {
                            height = d.y+padding_bottom
                        }
                        // elm.attr("transform", "translate("+d.x+","+oldY+")").transition().duration(bounceTime).ease(transitionEffect).attr("transform", "translate("+d.x+","+d.y+")")
                        elm.attr("transform", "translate("+d.x+","+d.y+")")
                        elm.attr("width", boxWidth+20).attr("height", boxHeight)
                            .on('mouseover', function () {
                                selectHighlights(d)
                            })
                            .on('click', function () {
                                clickEvent(d,i)
                            })
                            .on('dblclick', function () {
                                d3.event.stopPropagation();
                            })
                        elm.append("rect")
                            .attr("x", 0)
                            .attr("y", 0)
                            .attr("stroke", "#fff")
                            .attr("stroke-width", boxSpace+"px")
                            .attr("fill", servicesColor)
                            .attr("width", boxWidth)
                            .attr("height", boxHeight)

                        if ((filtersOn.resp_ip || filtersOn.resp_country) && (!filtersOn.service) && (!filtersOn.proto)) {
                            elm.append("text")
                                .text("+")
                                .attr("x", boxWidth+5)
                                .attr("y", boxHeight/1.5)
                                .attr("font-size","1.3em")
                                .attr("text-anchor","middle")
                                .attr("fill", "#000")
                        }
                    })
                    servi.append("text")
                        .text(function (d) {
                            return String(d.name).replace("N/A", "-");
                        })
                        .attr("x", boxWidth/2)
                        .attr("y", boxHeight/1.6)
                        .attr("font-size","1.1em")
                        .attr("text-anchor","middle")
                        .attr("fill", "#fff")
                    servi.append
                    servi.exit();
                }
                function drawServers() {
                    let servers = makeServersArray();
                    let oldY = 0;
                    serverSVG.selectAll('.server').remove();
                    let serv = serverSVG.selectAll(".server").data(servers.filter(function (d) { return checkFilter(d); }))
                    let serverCircle = serv.enter().append("g").attr("class", function (d) { return "server server-"+d.name;})
                    serverCircle.each(function (d, i) {

                        let elm = d3.select(this);
                        oldY = 0;
                        if (height < (d.y+padding_bottom)) {
                            height = d.y+padding_bottom
                        }
                        d.xr = ((width/1.3333));
                        d.y = (((circleRadius+circleStroke)*3))*i;
                        if (height < d.y) {
                            height = d.y
                        }
                        allMap[d.name+"server"] = d;
                        // elm.attr("transform", "translate("+d.xr+","+oldY+")").transition().duration(bounceTime).ease(transitionEffect).attr("transform", "translate("+d.xr+","+d.y+")")
                        elm.attr("transform", "translate("+d.xr+","+d.y+")")
                        elm.attr("width", boxWidth).attr("height", ((circleRadius+circleStroke)*2))
                            .on('mouseover', function () {
                                selectHighlights(d)
                            })
                            .on('click', function () {
                                clickEvent(d)
                            })
                            .on('dblclick', function () {
                                d3.event.stopPropagation();
                            })
                        elm.append("circle")
                            .attr("cx", (circleRadius+circleStroke))
                            .attr("cy", (circleRadius+circleStroke))
                            .attr("r", circleRadius)
                            .attr("stroke", "#000")
                            .attr("stroke-width", 2)
                            .attr("fill", function (d) {
                                return "#fff";
                            })

                        if ((!filtersOn.resp_ip) && (!filtersOn.resp_country) && (filtersOn.service && filtersOn.proto)) {
                            elm.append("text")
                                .text("+")
                                .attr("x", -(circleRadius+circleStroke))
                                .attr("y", boxHeight/1.5)
                                .attr("font-size","1.3em")
                                .attr("text-anchor","middle")
                                .attr("fill", "#000")
                        }

                    })
                    serv.append("text")
                        .text(function (d) {
                            if (d.type === "external") {
                                return d.name_toggle.replace("N/A" , "")
                            }
                            return d.name.replace("(N/A)" , "");
                        })
                        .attr("x", function (d) {
                            if (d.type === "external") {
                                return (38+(circleRadius+circleStroke))
                            }
                            return ((circleRadius+circleStroke)*2.1);
                        })
                        .attr("y", ((circleRadius+circleStroke)*1.5))
                        .attr("font-size","1.1em")
                        .attr("text-anchor","start")
                        .attr("fill", function (d) {
                            return "#000";
                        })

                    serv.append("g:foreignObject")
                        .attr('height', "28px")
                        .attr('width', "32px")
                        .attr('class', "serviceFlags")
                        .attr("transform", "translate(17,-"+circleRadius+")scale(0.75)")
                        .append("xhtml:g")
                            .classed("f32", true)
                        .append("g")
                            .attr("class", function (d) {
                                if (d.type === "external") {
                                    if (d.name === "n/a") { return "flag iana" }
                                    return (toggleFlag) ? "flag "+d.name : ""
                                }
                                return "flag "+d.name
                            })
                    serv.exit();
                }
                function drawClients() {
                    let oldY = 0;
                    let clients = makeClientsArray();
                    clientSVG.selectAll('.client').remove();
                    let cli = clientSVG.selectAll(".client").data(clients.filter(function (d) { return checkFilter(d); }))
                    let clientCircle = cli.enter().append("g").attr("class", function (d) { return "client client-"+d.name;})
                    clientCircle.each(function (d, i) {
                        let elm = d3.select(this);
                        oldY = 0;
                        if (d.y) {
                            oldY = d.y
                        }
                        d.x = ((width/4));
                        d.y = (((circleRadius+circleStroke)*3))*i;
                        allMap[d.name+"client"] = d;
                        if (height < (d.y+padding_bottom)) {
                            height = d.y+padding_bottom
                        }
                        // elm.attr("transform", "translate("+d.x+","+oldY+")").transition().duration(bounceTime).ease(transitionEffect).attr("transform", "translate("+d.x+","+d.y+")")
                        elm.attr("transform", "translate("+d.x+","+d.y+")")
                        elm.attr("width", boxWidth+20).attr("height", ((circleRadius+circleStroke)*2))
                            .on('mouseover', function () {
                                selectHighlights(d)
                            })
                            .on('click', function () {
                                clickEvent(d)
                            })
                            .on('dblclick', function () {
                                d3.event.stopPropagation();
                            })
                        elm.append("circle")
                            .attr("cx", (circleRadius+circleStroke))
                            .attr("cy", (circleRadius+circleStroke))
                            .attr("r", circleRadius)
                            .attr("stroke", "#000")
                            .attr("stroke-width", 2)
                            .attr("fill", function (d) {
                                return "#fff";
                            })

                    })
                    cli.append("text")
                        .text(function (d) {
                            if (d.type === "orig_external") {
                                return d.name_toggle.replace("N/A" , "")
                            }
                            return d.name.replace("(N/A)" , "");
                        })
                        .attr("x", function (d) {
                            if (d.type === "orig_external") {
                                return -(28+(circleRadius+circleStroke))
                            }
                            return -((circleRadius+circleStroke)/2);
                        })
                        .attr("y", ((circleRadius+circleStroke)*1.5))
                        .attr("font-size","1.1em")
                        .attr("text-anchor","end")
                        .attr("fill", function (d) {
                            return "#000";
                        })
                    cli.append("g:foreignObject")
                        .attr('height', "28px")
                        .attr('width', "32px")
                        .attr('class', "serviceFlags")
                        .attr("transform", "translate(-28,-"+circleRadius+")scale(0.75)")
                        .append("xhtml:g")
                            .classed("f32", true)
                        .append("g")
                            .attr("class", function (d) {
                                if (d.type === "orig_external") {
                                    if (d.name === "n/a") { return "flag iana" }
                                    return (toggleFlag) ? "flag "+d.name : ""
                                }
                                return "flag "+d.name
                            })
                    cli.exit();
                }
                function drawApplications() {
                    let apps = makeApplicationArray();
                    serviceSVG.selectAll('.app').remove();
                    let servi = serviceSVG.selectAll(".app").data(apps.filter(function (d) { return checkFilter(d); }))
                    let serviceRect = servi.enter().append("g").attr("class", function (d) { return "app app-"+d.name;})
                    serviceRect.each(function (d, i) {
                        let elm = d3.select(this);
                        // oldY = 0;
                        if (d.y) {
                            oldY = d.y
                        }
                        d.x = ((width/2)-(boxWidth/2));
                        d.xr = ((width/2)+(boxWidth/2));
                        d.y = (boxHeight)*(i+1);

                        allMap[d.name+"application"] = d;

                        if (height < (d.y+padding_bottom)) {
                            height = d.y+padding_bottom
                        }
                        // elm.attr("transform", "translate("+d.x+","+oldY+")").transition().duration(bounceTime).ease(transitionEffect).attr("transform", "translate("+d.x+","+d.y+")")
                        elm.attr("transform", "translate("+d.x+","+d.y+")")
                        elm.attr("width", boxWidth).attr("height", boxHeight)
                            .on('mouseover', function () {
                                selectHighlights(d)
                            })
                            .on('click', function () {
                                clickEvent(d,i)
                            })
                            .on('dblclick', function () {
                                d3.event.stopPropagation();
                            })
                        elm.append("rect")
                            .attr("x", 0)
                            .attr("y", 0)
                            .attr("stroke", "#fff")
                            .attr("stroke-width", boxSpace+"px")
                            .attr("fill", appsColor)
                            .attr("width", boxWidth)
                            .attr("height", boxHeight)
                    })
                    servi.append("text")
                        .text(function (d) {
                            return String(d.name).replace("N/A", "-");
                        })
                        .attr("x", boxWidth/2)
                        .attr("y", boxHeight/1.6)
                        .attr("font-size","1.1em")
                        .attr("text-anchor","middle")
                        .attr("fill", "#fff")
                    servi.exit();
                }
                function drawLinks() {
                    linksSVG.selectAll("path").remove()
                    var X = linksSVG.selectAll("path").data(points, getName);
                    X.enter().append("path").attr("d", function (Z) {
                        var S = Z.source ? {
                            x: Z.source.xr,
                            y: Z.source.y
                        } : {
                            x: 0,
                            y: 0
                        };
                        return diagonal({
                            source: S,
                            target: S
                        })
                    }).attr("class", "link")
                    .attr("fill", "none")
                    .attr("stroke", function (d) {
                        if (d.ioc) {
                            return iocColor
                        }
                        return "#aaa";
                    })
                    .attr("stroke-width", "1.5px")
                    .attr("opacity", 0.4);
                    X.exit().remove();
                    linksSVG.selectAll("path").attr("d", diagonal);
                }

                // ---------- Redraw Function ----------
                function redraw() {
                    if (servicesLength() > 1) {
                        clearApps();
                    } else {
                        setApplications();
                    }
                    if ((filtersOn.resp_ip || filtersOn.resp_country) && (filtersOn.service && filtersOn.proto)) {
                        setClients();
                    } else {
                        if (lineChartReq) {
                            requeryLineChart({});
                        }
                    }
                    allMap = {};
                    drawServices();
                    drawApplications();
                    drawServers();
                    drawClients();
                    setHeight();
                    setLinks();
                    drawLinks();
                }

                setServices();
                setServers();
                redraw();

                // set update functions
                $scope.$on('updatedData', function (event, id, initialLoad) {
                    if ($scope.main.dataObjects[key].group) {
                        if (id !== uid) { return }
                        if (typeof initialLoad === "object") {
                            if ($scope.main.dataObjects[key].settings.complete >= tableCalls.length) {
                                usSpinnerService.stop("spinner-"+uid);
                                $scope.page.complete = true;
                            }
                        } else {
                            if (typeof initialLoad === "undefined") {
                                $scope.main.dataObjects[key].dimension.dispose();
                                $scope.main.dataObjects[key].dimension = $scope.main.dataObjects[key].settings.dimension($scope.main.dataObjects[key].cf);
                                $scope.main.dataObjects[key].group = $scope.main.dataObjects[key].settings.group($scope.main.dataObjects[key].dimension);
                            }
                        }
                        services = {};
                        setServices();
                        setServers();
                        redraw();
                    }
                });

                window.onresize = function () {
                    if ($scope.page.w) {
                        width = element[0].clientWidth-20;
                        height = $scope.page.w[0].innerHeight+50;
                        svg.attr("width",width).attr("height",height);
                        redraw();
                    }
                }

                $scope.$on('$destroy', function () {
                    element = null;
                    $scope.page.w = null;
                    window.onresize = null;
                });
            })
        }
    }
}

directive.$inject = ['$location', '$window', 'fetchStream', 'generateId', 'usSpinnerService'];
module.exports = directive;



/** WEBPACK FOOTER **
 ** ./src/pages/directives/services/services.js
 **/